import { render, staticRenderFns } from "./CoOptionApproval.vue?vue&type=template&id=c9961406"
import script from "./CoOptionApproval.vue?vue&type=script&lang=js"
export * from "./CoOptionApproval.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports